var _defs, _g, _g2, _g3, _g4, _g5, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpteur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cpteur",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8cc63f;}.cls-2{fill:#d1be0f;}.cls-3{fill:#f7931e;}.cls-4{fill:#39b54a;}.cls-5{fill:#ff1d25;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vingt40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.46,7.2C62.28,15.64,41.38,31.07,26.19,51.08l40.48,29.41c9.03-11.58,21.2-20.59,35.24-25.72L86.46,7.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_0Soixante"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.42,52.96l15.47-47.6c-11.69-3.48-24.06-5.36-36.88-5.36s-25.84,1.97-37.8,5.63l15.46,47.58c7.08-2.09,14.58-3.21,22.33-3.21s14.6,1.05,21.42,2.96Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_04Vingt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.97,80.02l40.47-29.4c-15.35-20.03-36.42-35.44-60.79-43.75l-15.46,47.59c14.23,5,26.6,13.96,35.78,25.56Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_0Cent"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.94,84.04c8.86,12.76,14.06,28.25,14.06,44.96h50c0-27.69-8.74-53.34-23.6-74.35l-40.46,29.4Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "zeroVingt"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.25,55.12C8.6,76.05,0,101.52,0,129H50c0-16.5,5.06-31.81,13.71-44.48L23.25,55.12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "aiguille",
    d: "M129,115c-6.13,0-11.33,3.95-13.22,9.44l-93.66,3.1c-.62,.02-1.12,.67-1.12,1.47s.5,1.44,1.12,1.47l93.66,3.1c1.89,5.49,7.09,9.44,13.22,9.44,7.73,0,14-6.27,14-14s-6.27-14-14-14Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpteur);
export default __webpack_public_path__ + "static/media/cpteur.dc858a4ef90d890cd96b975abda5dff2.svg";
export { ForwardRef as ReactComponent };